import React from 'react';
import { MapContainer, TileLayer, Polygon, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon issue with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const ServiceAreaMap = () => {
  // Neath coordinates (center of our service area)
  const neathCenter = [51.6639, -3.8071];
  
  // Combined boundary for SA1-SA15 as one continuous area
  // Extended to include A465 corridor, Resolven, Glynneath, Pontneddfechan, Gower Peninsula, Pyle and Porthcawl
  const serviceAreaBoundary = [
    // Starting from northwest (Ystradgynlais area)
    [51.7900, -3.7600],
    [51.8000, -3.7300],
    // Along A465 to Glynneath - extended significantly to cover Glynneath village
    [51.8250, -3.7000],
    [51.8300, -3.6700],
    [51.8250, -3.6400],
    // Northeast boundary extended to include Pontneddfechan
    [51.8100, -3.6200],
    [51.7900, -3.5800],
    [51.7700, -3.5700],
    // Eastern boundary including Pontneddfechan and ensuring Resolven is covered
    [51.7500, -3.5800],
    [51.7300, -3.6200],
    [51.7100, -3.6600],
    // A465 corridor from Glynneath down to Neath (eastern side with Resolven)
    [51.7000, -3.7000],
    [51.6850, -3.7400],
    [51.6700, -3.7700],
    [51.6400, -3.7600],
    [51.5950, -3.7200],
    [51.5700, -3.7200],
    // Extended southeast to include Pyle
    [51.5500, -3.7100],
    [51.5300, -3.7000],
    // South including Porthcawl on the coast
    [51.5000, -3.7200],
    [51.4750, -3.7100],
    [51.4600, -3.7300],
    // Southwest coast
    [51.4500, -3.7800],
    [51.4700, -3.8400],
    [51.5200, -3.9500],
    // Southwest extending to Gower Peninsula
    [51.5400, -4.0500],
    [51.5500, -4.1500],
    [51.5600, -4.2000],
    // Extended to Rhossili on far western Gower
    [51.5650, -4.2600],
    [51.5690, -4.2900],
    // Llangennith area (north of Rhossili)
    [51.5850, -4.2850],
    [51.6000, -4.2750],
    [51.6100, -4.2600],
    // West (Llanelli - SA14/SA15) - adjusted to connect smoothly
    [51.6300, -4.2200],
    [51.6500, -4.1900],
    [51.6700, -4.1900],
    [51.6900, -4.1900],
    [51.7200, -4.1200],
    // Northwest (Gorseinon - SA4)
    [51.7300, -4.0500],
    [51.7200, -3.9500],
    // North through Pontardawe/Ystalyfera - western side of A465 corridor
    [51.7300, -3.8800],
    [51.7400, -3.8500],
    [51.7600, -3.8200],
    [51.7700, -3.8000],
    // Extended north to Ystradgynlais (western side)
    [51.7800, -3.7800],
    // Close the polygon back to start
    [51.7900, -3.7600]
  ];

  return (
    <div className="w-full h-[500px] rounded-xl overflow-hidden shadow-xl border-2 border-gray-200 relative z-10">
      <MapContainer 
        center={neathCenter} 
        zoom={10} 
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {/* Single continuous area covering SA1-SA15 */}
        <Polygon
          positions={serviceAreaBoundary}
          pathOptions={{
            color: '#06b6d4',
            fillColor: '#06b6d4',
            fillOpacity: 0.25,
            weight: 3
          }}
        />
        
        {/* Marker for Neath */}
        <Marker position={neathCenter}>
          <Popup>
            <div className="text-center">
              <strong className="text-lg">Neath</strong>
              <br />
              <span className="text-sm">Service Center</span>
              <br />
              <span className="text-xs text-gray-600">SA1-SA15 Coverage</span>
            </div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default ServiceAreaMap;
